// extracted by mini-css-extract-plugin
export var categoryWrapper = "ResourceCategories-module--categoryWrapper--foCJy";
export var categoryTitle = "ResourceCategories-module--categoryTitle--idlov";
export var categoryItem = "ResourceCategories-module--categoryItem--Uh3Qt";
export var categoryList = "ResourceCategories-module--categoryList--rnqLH";
export var dataContainer = "ResourceCategories-module--dataContainer--Kmsji";